var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFolderOutline = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  d: "M10.5 7h-.001a1 1 0 0 1-.718-.306zm0 0H20a1 1 0 0 1 1 1v9.714a1.3 1.3 0 0 1-.377.909 1.3 1.3 0 0 1-.91.377H4.287a1.3 1.3 0 0 1-.91-.377A1.3 1.3 0 0 1 3 17.715V6.285A1.29 1.29 0 0 1 4.286 5h3.432a1 1 0 0 1 .722.306l1.341 1.388z"
})));
export default SvgFolderOutline;